module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA7ElEQVQoU5WSMU7DQBBF/5e7cATwRg5CoUCiokBKR8Md4nVB7Dp1Ku7hjShYt+mhoaGhRpEgUih2cw4YFCMsOzgK2W5W/83Mnxliz8e6PrNKypgcmdjdteVqAKlVH1Ptj0f34VkADvPETzahPxVEeDVN3FNWhBcE4zz24zrUAG5s1A/kcwby1mg3ywo1h6BjtO/9Qg1g/ZkWh0f8Ch5AdABEAN4AOTB61S3ttRlLrXon0K+ykos8dqetwNo4gaoFQF6MXl22tpRZ9QxgUFUVvprEnW81Xe3hR7E02p/sHGspEDyaxF/vXNx/ruQbtVBHDXuDe0oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/6.png
// module id = bvch
// module chunks = 1